/**
 * Muhit o'zgaruvchilarining YAGONA o'qish nuqtasi.
 *
 * Ilova kodining qolgan qismi `import.meta.env` ga tegmaydi: shunda qaysi
 * o'zgaruvchilar borligini bilish uchun bitta faylni ochish kifoya va
 * testda ularni almashtirish oson.
 */

/**
 * Ishlab chiqarish build'ida API manzili localhost'ga qarab qolganini
 * TEKSHIRADI.
 *
 * Ilgari `.env.production` `.env.development` bilan bayt-bayt bir xil
 * turdi: CI yoki Docker o'zgaruvchini bermasa, bundle ichiga localhost
 * yozilib ketardi. HTTPS ostida esa har bir so'rov "mixed content" deb
 * bloklanadi va ilova sababsiz jim ishlamay qo'yadi. Shuning uchun bunday
 * build ishga tushishi kerak emas.
 */
const LOCAL_HOSTS = ["localhost", "127.0.0.1", "0.0.0.0", "[::1]"];

export const isLocalApiUrl = (url: string): boolean => {
  try {
    return LOCAL_HOSTS.includes(new URL(url).hostname);
  } catch {
    // Nisbiy manzil (masalan `/api/v1`) — reverse proxy orqali ishlaydi.
    return false;
  }
};

/**
 * Ikkala argument ham ATAYLAB majburiy: standart qiymat sifatida
 * `import.meta.env` ni o'qisak, `undefined` uzatilgan test o'sha standartga
 * tushib ketardi va tekshiruv hech narsani tekshirmasdi.
 */
export const assertApiBaseUrl = (url: string | undefined, isProduction: boolean): void => {
  if (!isProduction) return;

  if (!url) {
    throw new Error(
      "VITE_API_BASE_URL berilmagan. Ishlab chiqarish build'i API manzilisiz ishlay olmaydi.",
    );
  }

  if (isLocalApiUrl(url)) {
    throw new Error(
      `VITE_API_BASE_URL hali ham localhost'ga qarab turibdi (${url}). ` +
        "Ishlab chiqarish build'ida uni CI yoki Docker haqiqiy manzil bilan almashtirishi shart.",
    );
  }
};

/** Bo'sh satr berilmagan bilan barobar: `.env` da `VITE_X=` shunday chiqadi. */
const read = (value: string | undefined): string | undefined =>
  value && value.trim() !== "" ? value.trim() : undefined;

export const env = {
  API_BASE_URL: read(import.meta.env.VITE_API_BASE_URL) ?? "http://localhost:7777/api/v1",
  IS_PRODUCTION: import.meta.env.PROD,
} as const;

/**
 * Ilova ishga tushishida (`main.tsx`) chaqiriladi. Xato tashlasa — ilova
 * umuman chizilmaydi, va bu ataylab: noto'g'ri manzilli panel har bir
 * so'rovda jim yiqilgandan ko'ra, birinchi soniyada baqirgani yaxshi.
 */
export const assertEnv = (): void => {
  assertApiBaseUrl(import.meta.env.VITE_API_BASE_URL, import.meta.env.PROD);
};
